// extracted by mini-css-extract-plugin
export var active = "_i9-7";
export var blink = "_i9-8";
export var dropDownSelector = "_i9-4";
export var dropDownWrapper = "_i9-3";
export var fakeCursor = "_i9-6";
export var fontSizeButton = "_i9-9";
export var formQuillEditor = "_i9-0";
export var pressed = "_i9-a";
export var qlBlank = "_i9-1";
export var textFormattingToolbar = "_i9-2";
export var textToolbarOption = "_i9-5";